module.exports = __webpack_public_path__ + "r-v3/img/set_group.1052a554.svg";